/*
 * Presentación del incremento 6/6. TODO lo que aquí se escribe es presentación:
 * ninguna función de este archivo decide una regla de negocio.
 *
 * LO QUE NO ESTÁ AQUÍ, Y NO DEBE ESTAR (RNF-059):
 *   · no se compara ninguna fecha        · no se resta ningún importe
 *   · no se deduce ningún estado         · no se compone el texto del estado
 *   · no se concatena el contador «3/12» · no se ordena ninguna lista
 * Todo eso llega armado del servidor. Si una de estas funciones empezara a
 * calcular, sería defecto.
 *
 * El formato de importe lo resuelve la implementación única del núcleo (RN-147d):
 * aquí no se vuelve a formatear a mano, y `US$` está derogado (D-88, RN-147b).
 */

import { formatearImporte, SIN_IMPORTE } from '../../nucleo/importes/formatoDeImporte.js';
import { formatearFecha } from '../../nucleo/fecha/fechaLocal.js';
import { ESTADOS } from './api/vencimientosApi.js';

/**
 * Importe en la moneda de la tarjeta: "$1,234.56 MXN" / "$412.85 USD". No hay
 * conversión y las monedas NUNCA se combinan (RN-003, RN-275).
 *
 * Un importe NULO no se pinta como cero: cero significaría «no debes nada» y lo
 * que ocurre es que no se pudo saber (RNF-062, RN-288, RN-304).
 */
export function importe(valor, codigoISO) {
  if (valor === null || valor === undefined) return SIN_IMPORTE;
  return formatearImporte(valor, codigoISO);
}

/** dd/MM/aaaa, el formato de presentación del sistema (RNF-015). */
export const fecha = formatearFecha;

/** Clase de color de cada estado. Es presentación; el valor de lógica es la clave. */
export function claseDeEstado(claveEstado) {
  switch (claveEstado) {
    case ESTADOS.vencida: return 'e';
    case ESTADOS.porVencer: return 'w';
    case ESTADOS.pagada: return 'ok';
    case ESTADOS.sinSaldo: return 's';
    default: return 's';
  }
}

/**
 * Ícono de cada estado. EXISTE PORQUE EL COLOR NO PUEDE SER EL ÚNICO PORTADOR DEL
 * SIGNIFICADO: sin color, el estado se sigue leyendo por ícono y texto.
 */
export function iconoDeEstado(claveEstado) {
  switch (claveEstado) {
    case ESTADOS.vencida: return '!';
    case ESTADOS.porVencer: return '▲';
    case ESTADOS.pagada: return '✓';
    case ESTADOS.sinSaldo: return '◇';
    default: return '?';
  }
}

/** Nombre visible de la tarjeta con sus cuatro últimos dígitos, si los tiene. */
export function nombreDeTarjeta(tarjeta) {
  return tarjeta.cuatroUltimosDigitos
    ? `${tarjeta.nombreTarjeta} ·${tarjeta.cuatroUltimosDigitos}`
    : tarjeta.nombreTarjeta;
}

/** Iniciales para la insignia del renglón. Presentación pura. */
export function inicialesDeTarjeta(nombreTarjeta) {
  return (nombreTarjeta ?? '?')
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map((parte) => parte[0].toUpperCase())
    .join('');
}

/**
 * Texto fijo de la columna «Cuenta de origen» cuando el 3/6 no entregó el nombre
 * (D-199, RN-309). NUNCA el identificador, NUNCA una celda vacía y NUNCA el
 * nombre de una persona en su lugar.
 */
export const CUENTA_NO_DISPONIBLE = 'Cuenta no disponible';

export function nombreDeCuentaDeOrigen(movimiento) {
  const nombre = movimiento?.nombreCuenta;
  return typeof nombre === 'string' && nombre.trim() !== '' ? nombre : CUENTA_NO_DISPONIBLE;
}
